/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { object, array, func } from 'prop-types';
import classNames from 'clsx';

import { AGENT } from 'actions/signup';

import Button from 'components/Button/Button';
import Select from 'components/Form/Input/Select/Select';

import p from 'polyglot/polyglot';

import styles from './create-agent-role.scss';

/**
 * This is the CreateAgentRole component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export default class CreateAgentRole extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    user: object.isRequired,
    options: array.isRequired,
    onSubmit: func,
  };

  static defaultProps = {
    onSubmit: () => {},
  };

  state = {
    agencyId: '',
  };

  submitHandler = event => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    const { agencyId } = this.state;
    const {
      user: { loading },
      onSubmit,
    } = this.props;

    if (loading) return;

    onSubmit(AGENT, agencyId);
  };

  onChange = event => {
    const { value } = event.target;

    this.setState({ agencyId: value });
  };

  /**
   * Render CreateAgentRole.
   *
   * @return {Object}
   */
  render() {
    const { agencyId } = this.state;
    const {
      user: { loading },
      options,
    } = this.props;

    return (
      <div className={styles.wrapper}>
        <h3 className={styles.title}>
          {p.t('account.admin.create_agent_role.title')}
        </h3>

        <form
          className={classNames(styles.form, {
            [styles.loading]: loading,
          })}
          onSubmit={this.submitHandler}
          noValidate
          autoComplete="off"
          ref={ref => {
            this.form = ref;
          }}
        >
          <div className={styles.tags}>
            <p className={styles.label}>
              {p.t('account.admin.create_agent_role.form.agency_id.label')}
            </p>
            <Select
              name="agency_id"
              placeholder={p.t(
                'account.admin.create_agent_role.form.agency_id.placeholder'
              )}
              value={agencyId}
              options={options}
              onChange={this.onChange}
            />
          </div>

          <footer className={styles.footer}>
            <Button onClick={this.submitHandler} medium>
              {p.t('account.admin.create_agent_role.form.submit')}
            </Button>
          </footer>
        </form>
      </div>
    );
  }
}
